export default __webpack_public_path__ + "static/media/campground.da4370d9.svg";